import request from '../utils/request'
export const getSettings = () => request.get('/settings')
export const saveSettings = data => request.patch('/settings', data)
export const changePassword = data => request.post('/auth/change-password', data)
